import { useEffect } from "react";

const SITE = "https://buildease.co.za";

// Dedupe identical event+path pairs fired within one second — guards against
// StrictMode double-invoked effects inflating analytics in dev builds.
let _lastSignature = "";
let _lastTimestamp = 0;

export const trackEvent = (event, path = window.location.pathname) => {
    try {
        const signature = `${event}|${path}`;
        const now = Date.now();
        if (signature === _lastSignature && now - _lastTimestamp < 1000) return;
        _lastSignature = signature;
        _lastTimestamp = now;
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/events`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ event, path }),
        }).catch(() => {});
    } catch (e) {
        /* analytics must never break the UI */
    }
};

export const usePageSeo = (title, description) => {
    useEffect(() => {
        const meta = document.querySelector('meta[name="description"]');
        let canonical = document.querySelector('link[rel="canonical"]');
        const originalTitle = document.title;
        const originalDescription = meta?.content || "";
        const originalCanonical = canonical?.href || "";

        document.title = title;
        if (meta) meta.setAttribute("content", description);
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
        }
        canonical.href = SITE + window.location.pathname;
        trackEvent("page_view");

        return () => {
            document.title = originalTitle;
            if (meta && originalDescription)
                meta.setAttribute("content", originalDescription);
            if (canonical) {
                if (originalCanonical) canonical.href = originalCanonical;
                else canonical.remove();
            }
        };
    }, [title, description]);
};
